module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-04@2x.f91493a.webp";